{
    "button.copy": "Kopiera",
    "button.email": "E-post",
    "button.share": "Dela med sig",
    "button.sms": "SMS",
    "footer.poweredBy": "Drivs av <linkText> Ice Cream Social <\/linkText>",
    "footer.privacyPolicy": "Integritetspolicy",
    "footer.termsAndConditions": "Villkor",
    "offer.hint": "När {conversionGoal, plural, one {# vän gör ett köp } two {# vänner gör inköp } few {# vänner gör inköp } many {# vänner gör inköp } other {# vänner gör köp }} får du din belöning !",
    "optInMessage": "För att delta och dela med dina vänner, låt oss veta hur vi kontaktar dig med erbjudanden och belöningsuppdateringar",
    "order.confirmed": "Beställningsnummer {orderId} bekräftats!",
    "order.details": "Se beställningsdetaljer",
    "share.email.duplicateError": "Hoppsan! Du har redan lagt till det e-postmeddelandet.",
    "share.email.heading": "Bjud in vänner via e-post",
    "share.email.inputLabel": "Vännens e-postadress",
    "share.email.inputSubmit": "Stiga på",
    "share.email.invitesSubmit": "Skicka inbjudningar",
    "share.email.moreOptions": "Fler delningsalternativ",
    "share.email.subheading": "Ange dina vänners e-postadresser nedan",
    "share.general.help": "<bold> Har du problem? <\/bold> Appar kanske inte öppnas om de inte är installerade på din enhet, försök använda <bold2> Dela <\/bold2> via din personliga länk istället",
    "share.general.linkLabel": "Använd din personliga länk för att dela var som helst",
    "share.general.otherOptions": "Eller dela nu på dessa plattformar",
    "thankyou.dismissCTA": "Avfärda",
    "thankyou.heading": "Tack för att du delar med dig!",
    "thankyou.message": "Du är en mästare! Vi skickar uppdateringar om dina belöningsframsteg till din inkorg.",
    "thankyou.reminder": "Tänk på att du alltid kan besöka det här erbjudandet igen senare om du vill fortsätta dela.",
    "thankyou.shareCTA": "Fortsätt dela",
    "unlock.consentExplanation": "Vi kommer att kontakta dig med hjälp av den information du angett. Du kan avsluta prenumerationen när som helst, men du kan missa uppdateringar om ditt erbjudande",
    "unlock.consentPolicyExplanation": "Vi värdesätter din integritet. För att lära dig hur din information används, läs vår <linkText> Sekretess- och cookiepolicy <\/linkText>",
    "unlock.emailConsentOptIn": "Maila mig uppdateringar",
    "unlock.error.invalidEmail": "Ange en giltig e-postadress",
    "unlock.error.noConsent": "Vänligen samtyck till e-postkommunikation för att delta i detta erbjudande",
    "unlock.input": "Din e-postadress",
    "unlock.label": "Aktivera erbjudandet",
    "share.general.copySuccess": "✨ Länken kopierad!"
}